export const APP_ID = 'medibank-pp-web';
export const TENANT_ID = 'medibank-pp';

export const MASONRY = {
  ROOT_NODE_ID_HOME_PAGE: 'home$root',
  ROOT_NODE_APPOINTMENTS_LANDING_PAGE: 'appointmentsLanding$root',
  ROOT_NODE_APPOINTMENT_DETAILS_PAGE: 'appointmentDetails$web$root',
  ROOT_NODE_IN_PERSON_CONSULTATION_PAGE:
    'secondaryPages$inPersonConsultationWeb$root',
  ROOT_NODE_VIRTUAL_CONSULTATION_PAGE:
    'secondaryPages$virtualConsultationWeb$root',
  ROOT_NODE_LINKED_CENTRES_LANDING_PAGE: 'yourClinicsLanding$root',
};

export const QUERY_PARAM_MODAL_VALUE = {
  DELETE_ACCOUNT: 'delete-account',
  DELETE_ACCOUNT_DISCLAIMER: 'delete-account-disclaimer',
};

export enum QUERY_PARAM_KEYS {
  MODAL = 'modal',
  CANCEL_URL = 'cancelUrl',
}

export const ANALYTICS_DETAILS = {
  CANCEL_DELETION: 'cancel account deletion',
  CONFIRM_DELETION: 'delete account',
  ACKNOWLEDGE_DELETION: 'confirm account deletion',
  LOGIN: 'login',
  CONFIRM_TERMS: 'accept privacy policy and terms of service',
  CONFIRM_MARKETING: 'opt-in to email marketing',
  DECLINE_MARKETING: 'do not opt in to marketing',
  CONFIRM_MOBILE_NUMBER: 'confirm phone number',
  CONFIRM_VERIFICATION_CODE: 'verify mobile number',
  CHANGE_MOBILE_NUMBER: 'navigate to change mobile number',
  NAVIGATE_TO_HOME: 'navigate to patient portal home page',
  CONTINUE: 'continue',
  CONFIRM_PROFILE_INFORMATION: 'confirm profile information',
  NAVIGATE_TO_EDIT_PROFILE_INFORMATION: 'navigate to edit profile information',
  NAVIGATE_TO_ADD_A_CLINIC: 'navigate to add a clinic',
  HEADER_NAVIGATE_TO_HOME: 'navigate to home page',
  HEADER_NAVIGATE_TO_APPOINTMENTS: 'navigate to appointments landing page',
  HEADER_NAVIGATE_TO_DOCUMENTS: 'navigate to documents landing page',
  HEADER_NAVIGATE_TO_JOURNEY: 'navigate to journey landing page',
  USER_SETTINGS: 'navigate to settings page',
  USER_SETTINGS_SIGN_OUT: 'navigate to sign out',
  USER_SETTINGS_CONTACT_US: 'navigate to contact us page',
};

/**
 * Event names that are not covered by `EVENT_NAME` from
 * `@leagueplatform/analytics`. `trackAnalyticsEvent` accepts
 * `EVENT_NAME | string`, so these are passed through as-is.
 */
export const ANALYTICS_EVENT_NAMES = {
  BOOKING_COMPLETED: 'booking completed',
};

export const ANALYTICS_SCREEN_NAMES = {
  ACKNOWLEDGE_DELETION: 'delete account',
  LOGIN_ERROR: 'login error',
  LOGIN_SCREEN: 'login screen',
  ACCOUNT_SETUP_CONSENT_CAPTURE: 'account set up - consent capture',
  ACCOUNT_SETUP_MARKETING_CONSENT: 'account set up - marketing consent',
  ACCOUNT_SETUP_MOBILE_VERIFICATION: 'account set up - mobile verification',
  ACCOUNT_SETUP_MOBILE_VERIFICATION_CODE: 'account set up - verification code',
  ACCOUNT_SETUP_COMPLETE: 'account set up - completion',
  ACCOUNT_SETUP_PROFILE_INFORMATION: 'account set up - edit profile',
  ACCOUNT_SETUP_REVIEW_PROFILE_INFORMATION:
    'account set up - review profile information',
  PROFILE_SETTINGS_PERSONAL_INFORMATION:
    'profile settings - personal information',
  CONTACT_US: 'contact us',
  DELETE_CONFIRMATION_MODAL: 'delete account confirmation',
  APPOINTMENT_BOOKING_IFRAME: 'appointment booking iframe',
};

export const AUTH0_ERROR_TYPES = {
  LOGIN_REQUIRED: 'login_required',
};

export const SUB_PRODUCT_AREA_NAMES = {
  SIGN_IN: 'sign in',
  AUTHENTICATION: 'authentication',
  ONBOARDING: 'onboarding',
  APPOINTMENT: 'appointment booking',
  HEALTH_JOURNEY: 'health journey',
};

export const ANALYTICS_PRODUCT_AREA_NAMES = {
  FOUNDATION: 'foundation',
};

export const SECONDARY_CONTENT_MAX_WIDTH = '772px';

export const DAY_MONTH_YEAR_DATE_FORMAT: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
};

export const BOOKING_SOURCE = {
  AMPLAR: 'amplar',
  MY_HEALTH: 'myhealth',
} as const;

export type BookingSource =
  (typeof BOOKING_SOURCE)[keyof typeof BOOKING_SOURCE];
